import { Close } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  styled,
} from "@mui/material";
import React from "react";
import { Suspense } from "react";
import { useEffect } from "react";
import { useState } from "react";
import ImageComponent from "../WarehouseOrderCard/ImageComponent";

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& h2": {
    background: theme.palette.primary.main,
    color: "#fff",
    fontWeight: "500",
  },
}));

const DetailsDiv = styled(Box)(({ theme }) => ({
  background: "#fff",
  "& img": {
    height: "50px",
    width: "50px",
    objectFit: "contain",
    borderRadius: "5px",
  },
  "& p": {
    margin: "0",
    marginTop: "10px",
    marginBottom: "0",
  },
  "& small": {
    color: "grey",
    fontSize: "12px",
    lineHeight: "1.4",
  },
}));

const ViewWarehouseOrderList = (props) => {
  const [dialogDetails, setDialogDetails] = useState({
    open: true,
  });


  useEffect(() => {
    props.sendViewDetails(dialogDetails);
  }, [dialogDetails]);

  const handleClose = () => {
    setDialogDetails({
      ...dialogDetails,
      open: false,
    });
  };

  return (
    <StyledDialog
      open={dialogDetails.open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        View {props.print ? props.viewDetails?.order_info?.documenttype : props.viewDetails?.documenttype} - {props.print ? props.viewDetails?.order_info?.salesid : props.viewDetails?.salesid}
        <div>
          <span style={{ fontSize: "16px" }}><b> School</b> - {props.print ? props.viewDetails?.order_info?.school_info?.SchoolName : props.viewDetails.school_info?.SchoolName}</span>
          <IconButton onClick={handleClose}>
            <Close style={{ color: "#fff" }} />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent>
        <Box
          display={"grid"}
          gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
          alignItems={"center"}
          justifyContent={"center"}
          gap="10px"
          mb={1}
        >
          <div>
            <h4>Image</h4>
          </div>
          <div>
            <h4>Item</h4>
          </div>
          <div>
            <h4>Quantity</h4>
          </div>
          <Box textAlign={"right"}>
            <h4>Price</h4>
          </Box>
        </Box>
        <DetailsDiv>
          {props.print ? props.viewDetails?.sales_lines?.map((sales, index) => {
            return (
              
              <Box
                display={"grid"}
                gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
                alignItems={"center"}
                gap="10px"
                key={sales.id}
                mb={1}
              >
                <div>
                  <Suspense>
                    <ImageComponent
                      imageUrl={sales?.line_details?.ax_details?.imageUrl}
                      alt={`sales-${sales.id}`}
                    />
                  </Suspense>
                </div>
                <div>
                  <p>{sales?.line_details?.itemname}</p>
                  <div style={{ lineHeight: "1.0" }}>
                    <small>Colour: {sales?.line_details?.ax_details?.ColourName}</small>
                    <br />
                    <small>Size: {sales?.line_details?.ax_details?.SizeID}</small>
                  </div>
                </div>
                <Box textAlign={"center"}>
                  <p>{props.check ? parseInt(sales?.quantity) : parseInt(sales?.quantity)}</p>
                </Box>
                <Box textAlign={"right"}>
                  {sales?.line_details?.lineamount === null ? "" : `$${parseFloat(sales?.line_details?.lineamount).toFixed(2)}`}
                </Box>
              </Box>
            );
          }) : props.viewDetails?.sales_lines?.map((sales, index) => {
            return (
              <Box
                display={"grid"}
                gridTemplateColumns={"1fr 3fr 0.5fr 1fr"}
                alignItems={"center"}
                gap="10px"
                key={sales.id}
                mb={1}
              >
                <div>
                  <Suspense>
                    <ImageComponent
                      imageUrl={sales?.ax_details?.imageUrl}
                      alt={`sales-${sales.id}`}
                    />
                  </Suspense>
                </div>
                <div>
                  <p>{sales?.itemname}</p>
                  <div style={{ lineHeight: "1.0" }}>
                    <small>Colour: {sales?.ax_details?.ColourName}</small>
                    <br />
                    <small>Size: {sales?.ax_details?.SizeID}</small>
                  </div>
                </div>
                <Box textAlign={"center"}>
                  {/* <p>{props.check ? parseInt(sales?.totalFulfilledQty) : parseInt(sales?.actual_total_lines) - parseInt(sales?.totalFulfilledQty)}</p> */}
                  <p>{props.check ? parseInt(sales?.totalFulfilledQty) : parseInt(sales?.quantity)}</p>
                </Box>
                <Box textAlign={"right"}>
                  {sales?.lineamount === null ? "" : `$${parseFloat(sales?.lineamount).toFixed(2)}`}
                </Box>
              </Box>
            );
          })}
          {props.print && (
            <Box textAlign={"right"}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => props.handleRePrintTaxInvoice(props.viewDetails)}
              >
                Reprint Invoice
              </Button>
            </Box>
          )}

        </DetailsDiv>
      </DialogContent>
    </StyledDialog>
  );
};

export default ViewWarehouseOrderList;
